import Vue from 'vue'
import { URL_MANAGEMENT, URL_ORGANIZATIONS } from '@/constants/urls.js'
import { REPORTS, ERRORS, AXIOS_REQUESTS, GENERAL_FILES } from '@/constants/store.js'

const state = {
  [REPORTS.STATE.PROTOCOL_SIGNATURES_PIVOT_INFO]: null
}
const actions = {
  async [REPORTS.ACTIONS.GET_ORGANIZATIONS_REPORT] ({ dispatch }, params) {
    const url = `${Vue.getIdentityHost()}${URL_ORGANIZATIONS}/report?${Vue.helpers.getQueryParamsString(params)}`

    await dispatch(GENERAL_FILES.ACTIONS.DOWNLOAD_FILE_WITH_SETTINGS, url, { root: true })
  },
  async [REPORTS.ACTIONS.GET_ORGANIZATIONS_ACTIVITY_REPORT] ({ dispatch }, params) {
    const url = `${Vue.getAdminHost()}${URL_MANAGEMENT}/activity/statistics?${Vue.helpers.getQueryParamsString(params)}`

    await dispatch(GENERAL_FILES.ACTIONS.DOWNLOAD_FILE_WITH_SETTINGS, url, { root: true })
  },
  async [REPORTS.ACTIONS.GET_PROTOCOL_SIGNATURES_PIVOT_INFO] ({ commit, dispatch }, params) {
    const model = {
      url: `${Vue.getAdminHost()}${URL_MANAGEMENT}/protocolSignaturesInfo?${Vue.helpers.getQueryParamsString(params)}`
    }
    const resp = await dispatch(AXIOS_REQUESTS.ACTIONS.GET_AXIOS_REQUEST, model, { root: true })
    commit(ERRORS.MUTATIONS.ERROR_CLEAR, null, { root: true })
    commit(REPORTS.MUTATIONS.GET_PROTOCOL_SIGNATURES_PIVOT_INFO, resp.data)
  },
  async [REPORTS.ACTIONS.CLEAR_PROTOCOL_SIGNATURES_PIVOT_INFO] ({ commit }) {
    commit(REPORTS.MUTATIONS.CLEAR_PROTOCOL_SIGNATURES_PIVOT_INFO)
  }
}
const mutations = {
  [REPORTS.MUTATIONS.GET_PROTOCOL_SIGNATURES_PIVOT_INFO] (state, model) {
    state[REPORTS.STATE.PROTOCOL_SIGNATURES_PIVOT_INFO] = model
  },
  [REPORTS.MUTATIONS.CLEAR_PROTOCOL_SIGNATURES_PIVOT_INFO] (state) {
    state[REPORTS.STATE.PROTOCOL_SIGNATURES_PIVOT_INFO] = null
  }
}
export default {
  namespaced: true,
  state,
  actions,
  mutations
}
